import React from 'react'
import { Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useSlsStateContext } from '@fs/zion-sls'

export default function RedactionButton() {
  const { t } = useTranslation()
  const { currentImageArk } = useSlsStateContext()

  // URL-encode the ARK to ensure it's safe for use in a URL query parameter
  const encodedImageArk = currentImageArk ? currentImageArk.replace(/:/g, '%3A') : ''

  return (
    <Button
      external
      emphasis="medium"
      to={`/records/manager/redaction?imageArk=${encodedImageArk}`}
      label={t('shared-image-viewer.redaction-link', 'Redaction Link')}
      linkName="redaction-link-button"
    >
      {t('shared-image-viewer.redaction.button.open-image', 'Open Image')}
    </Button>
  )
}
